// src/components/trades/analysis/WarningsSection.js
import React from 'react';
import { dynastyTheme } from '../../../services/colorService';
import { AlertTriangle } from 'lucide-react';

export const WarningsSection = ({ warnings }) => {
  if (!warnings || warnings.length === 0) return null;

  return (
    <div className={`p-4 rounded-lg border border-red-500/50 bg-red-500/10 ${dynastyTheme.classes.bg.darkCard}`}>
      <h3 className="text-lg font-bold text-red-400 mb-3 flex items-center gap-2">
        <AlertTriangle className="w-5 h-5" />
        Warnings
      </h3>
      <ul className="space-y-2">
        {warnings.map((warning, idx) => (
          <li key={idx} className="flex items-start gap-2 text-sm text-red-300">
            <span className="text-red-400 mt-0.5">•</span>
            <span>{warning}</span>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default WarningsSection;
